import React from 'react';

interface LoyaltyBannerMobileProps {
  credit: string;
  titleLine1?: string;
  titleLine2?: string;
}

export const LoyaltyBannerMobile = ({
  credit,
  titleLine1 = 'Your',
  titleLine2 = 'SkinSociety',
}: LoyaltyBannerMobileProps) => {
  return (
    <div
      className="relative w-full h-[112px] rounded-[12px] overflow-hidden"
      style={{ background: 'linear-gradient(to top left, #311275, #754DCC)' }}
    >
      <div className="relative h-full flex items-center justify-between px-4 z-[1]">
        {/* Left Side - Title */}
        <div className="flex flex-col gap-0">
          <p className="text-primary-100 text-heading-h6-mobile font-bold">{titleLine1}</p>
          <p className="text-primary-100 text-heading-h6-mobile font-bold">{titleLine2}</p>
        </div>

        {/* Right Side - Credit */}
        <p className="text-white text-heading-h3-mobile font-bold">
          {credit}
        </p>
      </div>
    </div>
  );
};
